export function haversine(a, b) {
  // returns meters
  const R = 6371000;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export function pathLength(points) {
  let d = 0;
  for (let i = 1; i < points.length; i++) d += haversine(points[i - 1], points[i]);
  return d;
}

// Area in square meters via equirectangular projection + shoelace
export function polygonArea(points) {
  if (points.length < 3) return 0;
  const R = 6371000;
  const lat0 = (points.reduce((s, p) => s + p.lat, 0) / points.length) * Math.PI / 180;
  const xy = points.map((p) => ({
    x: (p.lng * Math.PI / 180) * R * Math.cos(lat0),
    y: (p.lat * Math.PI / 180) * R,
  }));
  let area = 0;
  for (let i = 0; i < xy.length; i++) {
    const j = (i + 1) % xy.length;
    area += xy[i].x * xy[j].y - xy[j].x * xy[i].y;
  }
  return Math.abs(area / 2);
}

export const M_TO_FT = 3.28084;

export function fmtDist(m) {
  const ft = m * M_TO_FT;
  if (ft < 1000) return `${ft.toFixed(0)} ft`;
  return `${(ft / 5280).toFixed(2)} mi`;
}

export function fmtArea(m2) {
  const sqft = m2 * M_TO_FT * M_TO_FT;
  const acres = sqft / 43560;
  if (acres < 1) return `${sqft.toFixed(0)} ft²`;
  return `${acres.toFixed(2)} ac`;
}
